import { useMutation } from '@tanstack/react-query';

import { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadDigitalTwins = {
  mutationConfig?: MutationConfig<typeof uploadDigitalTwins>;
};

type UpdateDigitalTwin = {
  mutationConfig?: MutationConfig<typeof updateDigitalTwin>;
};

export type UploadDigitalTwinsType = {
  id: string;
  name: string;
  file: File;
  source: string;
};

type UpdateDigitalTwinType = Pick<UploadDigitalTwinsType, 'name' | 'id'>;

const uploadDigitalTwins = ({ id, ...body }: UploadDigitalTwinsType) => {
  return extractData(api.estates({ id })['digital-twins'].post(body));
};

export const useUploadDigitalTwins = ({ mutationConfig }: UploadDigitalTwins = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadDigitalTwins,
  });
};

const updateDigitalTwin = ({ id, name }: UpdateDigitalTwinType) => {
  return extractData(api['digital-twins']({ id }).patch({ name }));
};

export const useUpdateDigitalTwin = ({ mutationConfig }: UpdateDigitalTwin = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: updateDigitalTwin,
  });
};
